// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import * as actions from './actions'

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------- Reducers
// ----------------------------------------------------------------------------
/**
    * rootReducer - Root reducer for this package.
    * Root reducer is not called directly, but is comubined and used by Redux to initialise and manage state.
    *
    * @example
      dispatch(someAction({...somePayload...}));
    *
    * @param {object} previousState - A simple object that contains previous state. Default value is an empty object.
    * @param {object} action - An action object of the nature { type: ACTION_KEYWORD, payload: payloadObject }
    * @version 0.0.1
    * @todo none
    */
const rootReducer = (
  previousState = {
    counter: 0,
    gridOverlayView: false,
    gridOverlay: 'six-col',
    dayNightMode: 'day',
    color: 'c-0',
    headerState: {
      open: false,
    },
    mediaState: {
      isExtraLargeDesktop: false,
      isLargeDesktop: true,
      isDesktop: false,
      isTablet: false,
      isMobile: false,
      isPortrait: false,
      isRetina: false,
    },
    screenSizeState: {
      screenWidth: 1440,
      screenHeight: 900,
    },
  },
  action
) => {
  switch (action.type) {
    case actions.INCREASE:
      return Object.assign({}, previousState, {
        counter: action.payload,
      })
    case actions.DECREASE:
      return Object.assign({}, previousState, {
        counter: action.payload,
      })
    case actions.UPDATE_MEDIA_STATE:
      return Object.assign({}, previousState, {
        mediaState: action.payload,
      })
    case actions.UPDATE_SCREEN_SIZE_STATE:
      return Object.assign({}, previousState, {
        screenSizeState: action.payload,
      })
    case actions.UPDATE_HEADER_STATE:
      return Object.assign({}, previousState, {
        headerState: action.payload,
      })
    case actions.UPDATE_GRID_OVERLAY_VIEW_STATE:
      return Object.assign({}, previousState, {
        gridOverlayView: action.payload,
      })
    case actions.UPDATE_GRID_OVERLAY_STATE:
      return Object.assign({}, previousState, {
        gridOverlay: action.payload,
      })
    case actions.UPDATE_DAY_NIGHT_MODE:
      return Object.assign({}, previousState, {
        dayNightMode: action.payload,
      })
    case actions.UPDATE_COLOR:
      return Object.assign({}, previousState, {
        color: action.payload,
      })
    default:
      return previousState
  }
}

// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------
export default rootReducer
